const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
export const IP_GEOLOCATION_ENDPOINT = `${API_BASE_URL}/geo`;

/**
 * Available geolocation provider types
 * - 'maxmind': Uses the server-side MaxMind GeoLite2 database via /api/geo
 * - 'ip-api': Uses ip-api.com directly (HTTP only, 45 req/min limit)
 */
export type GeoProviderType = 'maxmind' | 'ip-api';

/**
 * The configured geolocation provider
 * Set via VITE_GEO_PROVIDER environment variable
 * Defaults to 'maxmind' if not specified
 */
export const GEO_PROVIDER: GeoProviderType =
    (import.meta.env.VITE_GEO_PROVIDER as GeoProviderType) || 'maxmind';

export const GEOLOCATION_OPTIONS = {
    enableHighAccuracy: false, // Explicit consent for coarse/fast location usually implies we don't need GPS precise to the meter for this viz
    timeout: 10000,           // 10 seconds timeout
    maximumAge: 60000         // Cache valid for 60 seconds
};
